module.exports = __webpack_public_path__ + "assets/retina_Angle3Detailed.3e129e312c8a20beacc7a8063cc4ac7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle3Detailed.png
// module id = 614
// module chunks = 0